import React from 'react'

import NewIncome from './NewIncome/index'
import Income from './Income'

class AdditionalIncomes extends React.Component {
  state = {
  }

  onNewIncomeClick = (payload) => {
    this.props.onNewIncome(payload)
  }

  newIncomeCollapsed() {
    let activeIncomes = this.props.incomes.filter( (income) => {
      return income._destroy !== 1
    })

    return activeIncomes.length > 0
  }

  renderIncomes(incomes, availableIncomes) {
    const {
      currentApplicant,
      errors,
    } = this.props

    return incomes.map((option) => (
      <Income
        errors={ errors.get(option) }
        key={ option.key }
        id={ option.key }
        currentApplicant={currentApplicant}
        availableIncomes={ availableIncomes }
      />
    ))
  }

  render() {
    const {
      incomes,
      availableIncomes,
    } = this.props

    return(
      <div>
        <div className='card card-single select-commitment'>
          <div className='card-body'>
            <div className='qn'>Additional income sources</div>
            <p className='grey'>If applicable, please provide details of additional income sources you have:</p>

            { this.renderIncomes(incomes, availableIncomes) }

            <NewIncome
              availableIncomes={ availableIncomes }
              onNewIncomeClick={ this.onNewIncomeClick }
              collapsed={ this.newIncomeCollapsed() }
            />
          </div>
        </div>

      </div>
    )
  }
}

export default AdditionalIncomes
